import { render, staticRenderFns } from "./subheader.vue?vue&type=template&id=52909893&scoped=true"
import script from "./subheader.vue?vue&type=script&lang=js"
export * from "./subheader.vue?vue&type=script&lang=js"
import style0 from "./subheader.vue?vue&type=style&index=0&id=52909893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52909893",
  null
  
)

export default component.exports